// @flow

const ACTION_TYPES = {
  INIT: 'INIT',
  FETCH_LINK_TOKEN: 'FETCH_LINK_TOKEN',
  DELETE_LINK_TOKEN: 'DELETE_LINK_TOKEN',

  // config
  FETCH_CONFIG: 'FETCH_CONFIG',

  // navigation
  NAVIGATE_TO: 'NAVIGATE_TO',
  NAVIGATE_BACK: 'NAVIGATE_BACK',

  // merchants
  FETCH_MERCHANTS: 'FETCH_MERCHANTS',

  // accounts
  LINK_ACCOUNT: 'LINK_ACCOUNT',
  LINK_PLAID_ACCOUNT: 'LINK_PLAID_ACCOUNT',
  LINK_MX_ACCOUNT: 'LINK_MX_ACCOUNT',
}

export type TActionType = $Keys<typeof ACTION_TYPES>;
export default ACTION_TYPES;
